import { useEffect } from 'react';
import { IoClose } from 'react-icons/io5';
import { ToastItem } from '../hooks/useToast';

interface Props {
  toast: ToastItem;
  onDismiss: (id: string) => void;
}

const Toast = ({ toast, onDismiss }: Props) => {
  const { id, message, type, duration, count } = toast;
  const isError = type === 'error';

  // `count` is a dep so a collapsed duplicate (count bump) resets the timer,
  // keeping the toast visible for `duration` after the last occurrence.
  useEffect(() => {
    if (duration <= 0) {
      return;
    }
    const timer = window.setTimeout(() => onDismiss(id), duration);
    return () => window.clearTimeout(timer);
  }, [id, duration, count, onDismiss]);

  return (
    <div
      className={`toast toast--${type}`}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
    >
      <span className="toast__message">{message}</span>
      {count > 1 && (
        <span className="toast__count" aria-label={`Ponovljeno ${count} puta`}>
          ×{count}
        </span>
      )}
      <button
        type="button"
        className="toast__close"
        aria-label="Zatvori obaveštenje"
        onClick={() => onDismiss(id)}
      >
        <IoClose aria-hidden="true" />
      </button>
    </div>
  );
};

export default Toast;
